var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94 10.24L3.48 7L3.58 6.9C6.1 6.8 7.08 6.14 7.08 5.08V5.04C7.08 4.14 6.4 3.62 5.24 3.62C4.12 3.62 3.16 4.08 2.24 5L0.4 2.98C1.56 1.7 3.12 0.819999 5.3 0.819999C8.18 0.819999 10.14 2.3 10.14 4.96V5C10.14 7.54 8.38 8.58 6.2 9.02L5.98 10.24H3.94ZM3.28 15V11.8H6.52V15H3.28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizQuestionIcon);
export default __webpack_public_path__ + "static/media/quiz_question_icon.28dd3292b70743a754ff846bd4492649.svg";
export { ForwardRef as ReactComponent };